import { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { LoginState } from './global/LoginState'
import DashboardRoutes from './routes/DashboardRoutes'
import LandingRoutes from './routes/LandingRoutes'
import Loader from './utils/Loader'
import Alert from './utils/Alert'
import TokenChecker from './services/TokenChecker'
import Tostify from './utils/Tostify'

function App() {
  const loginState = useRecoilValue(LoginState)

  return (
    <BrowserRouter>
      <TokenChecker />
      <Suspense fallback={<div>Loading...</div>}>
        <Loader />
        <Alert />
        {loginState.isLoggedIn ? <DashboardRoutes /> : <LandingRoutes />}
        <Tostify />
      </Suspense>
    </BrowserRouter>
  )
}

export default App
  